import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { TransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-transformation.adapter';
import { FLOW } from '../IDataflow';
import { DataFlowSchemaAdapterUtils } from '../dataflow-schema-adapter-utils';
import { GuardTransformation } from 'app/model/dataflow/guardtransformation';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(GuardTransformation),
    asynchronous: true
})
export class GuardTransformationAdapter extends TransformationAdapter<GuardTransformation> {
    public async getDslScript(transformation: GuardTransformation): Promise<string> {
        const props: string[] = [DataFlowSchemaAdapterUtils.getOutputDefinitionDsl(transformation)];
        const expression = props.filter((prop) => !!prop).join(',\n\t');
        const partition = TransformationAdapter.getPartitionDslScript(transformation);

        const knownProps = `${expression}${partition ? ',\n\t' : ''}${partition}`;
        const unknownProps = this._getUnknownProps(transformation, knownProps);
        const transformationData = [knownProps, unknownProps].filter((c) => !!c).join(',\n\t');

        return (
            `${this._getInputStreams(transformation)} ${GuardTransformation.MODEL.name}(${transformationData}) ` +
            `${FLOW} ${this._getOutputStreams(transformation)}`
        );
    }
}
